
import React, { Component } from 'react';
import Paper from '@material-ui/core/Paper';
import TableContainer from '@material-ui/core/TableContainer';
import { Link } from 'react-router-dom';
import AddIcon from '@material-ui/icons/Add';
import TableListFooter from 'core/TableListFooter';
import Layout from 'components/Dashboard/Layout';
import { ListContext, ListProvider } from 'core/ListProvider';
import { YellowButton } from 'ui/Button';
import SearchWidget from 'form/SearchWidget';
import PointListTable from './ListTable';
import { UserContext, hasAccountPermission } from 'components/User';
import { ResponsiveTable } from 'ui/Table';


export default class PointList extends Component {

  static contextType = UserContext;

  componentDidMount() {
    document.title = 'Точки';
  }

  onDetail = (item) => {
    this.props.history.push(`/point/${item.id}`);
  };

  render() {
    return (
      <ListProvider
        url={'catalog/point'}
      >
        <ListContext.Consumer>
          {context => {
            const { items, permissions } = context;
            let addButton = undefined;
            if (hasAccountPermission(this.context, 'catalog.add_point')) {
              addButton = (
                <YellowButton
                  component={Link}
                  to={`/point/add`}
                  startIcon={<AddIcon />}
                >
                  Добавить точку
                </YellowButton>
              );
            }

            return (
              <Layout>
                <Layout.Header
                  title={'Точки'}
                  search={
                    <SearchWidget
                      value={context.filter.q}
                      onChange={(value) => context.setFilterValue('q', value)}
                    />
                  }
                  right={addButton}
                />
                <Layout.ContentSimple>
                  <TableContainer component={Paper}>
                    <ResponsiveTable>
                      <PointListTable
                        items={items}
                        onDetail={(item) => this.onDetail(item)}
                        hasChangePermission={permissions.change}
                      />
                      <TableListFooter colspan={6} />
                    </ResponsiveTable>
                  </TableContainer>
                </Layout.ContentSimple>
              </Layout>
            )
          }}
        </ListContext.Consumer>
      </ListProvider>
    )
  }
}
